import { Navigate } from 'react-router-dom';
import { useSession } from '../hooks/useSession.tsx';
import { useT } from '../i18n/index.ts';

/**
 * `/` entry redirect (forked local from the console-shared
 * `createRootRedirect` factory, epic #897 PR 3 — identical behavior).
 */

export function RootRedirect(): JSX.Element {
  const { status } = useSession();
  const t = useT();

  if (status === 'loading') {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-canvas px-8 text-sm text-paper-low"
        role="status"
        aria-live="polite"
      >
        <p>{t('common.session.checking')}</p>
      </div>
    );
  }

  if (status === 'authenticated') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
}
